import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useTranslations } from "../context/TranslationContext";
import VideoQuestionsEditor from ".";
import fetchCustom from "@helpers/fetchCustom";
import getResponseJson from "@helpers/getResponseJson";
import Icon from "@components/core/Icon";
import Button from "@components/legacy/core/Button";

const VideoApplicationQuestionsEditors = forwardRef(({ jobId, hideAddButton = false, onSaveComplete }, ref) => {
    const { t, updateTranslations } = useTranslations();
    const [data, setData] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            const response = await fetchCustom(`/api/jobs/${jobId}/ui?expand=video_application_questions`);
            if (!response.ok) {
                setData(null);
                setLoading(false);
                return;
            }
            const responseJson = await getResponseJson(response);
            setData(responseJson.video_application_questions || {});
            updateTranslations(responseJson?.video_application_questions?.translations || {});
            setLoading(false);
        };
        fetchData();
    }, [jobId]);

    useImperativeHandle(ref, () => ({
        showModal: () => {
            handleShowModal();
        },
        closeModal: () => {
            handleCloseModal(false);
        },
    }));

    if (loading) {
        return null;
    }

    if (!data) {
        return <span className="text-danger">Failed to fetch video questions</span>;
    }

    const getVideoQuestionsApi = data?._links?.get?.url;
    const putVideoQuestionsApi = data?._links?.put?.url;
    const videoRecorderMetadataApi = data?._links?.get_video_application_questions_editor_metadata?.url;
    const metadata = JSON.parse(data?.metadata || '{}');

    const handleShowModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleSave = (response) => {
        if (!response?.form) return;
        setData(response?.form);
        onSaveComplete?.();
        handleCloseModal();
    };

    return (
        <React.Fragment>
            {!hideAddButton && (
                <Button type="link" onClick={handleShowModal} isLink>
                    <Icon value="video-recorder" />
                    {t('Add video questions')}
                </Button>
            )}
            {showModal && <VideoQuestionsEditor
                jobId={jobId}
                type="video_application_questions"
                onCloseModal={handleCloseModal}
                showModal={showModal}
                onSave={handleSave}
            />}
        </React.Fragment>
    );
});

export default VideoApplicationQuestionsEditors;
